import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAdmin, isAdminOrProjectManager, isProjectManager } from '../utils/roles';

export const Route = createFileRoute('/project-settings/')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdminOrProjectManager(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }

    if (isProjectManager(user?.role) && !isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }

    throw redirect({
      to: '/project-settings/employee-project-models',
    });
  },
});
